// ABOUTME: Confirmation modal shown before saving a return line whose product belongs to multiple relations.
// ABOUTME: Renders the ReturnLocationDuplicate notice (no title) with cancel/confirm buttons that gate doSave().

import { Box, useTheme } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { useTranslation } from "react-i18next";

import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";

const MReturnLocationDuplicate = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();

    const isStandAlone = window.matchMedia("(display-mode: standalone)").matches;

    const handleConfirm = () => {
        if (props.onConfirm) props.onConfirm();
        props.handleClose();
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleConfirm();
    };

    return (
        <SHModal
            open={props.open}
            onClose={props.handleClose}
            onKeyDown={handleKeyDown}
        >
            <Box sx={{ maxWidth: 500 }}>
                <Box
                    sx={{
                        background:
                            theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                        borderTopLeftRadius: 16,
                        borderTopRightRadius: 16,
                        px: 3,
                        pt: 3,
                        pb: 2,
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Box
                        sx={{
                            borderRadius: 3,
                            background: colors.orange[100],
                            p: 2,
                            py: 1.5,
                        }}
                    >
                        <Subheading variant="orange"
                            sx={{
                                overflow:"visible",
                                whiteSpace:"normal"
                            }}
                        >
                            {t("this_product_belongs_to_multiple_relations")}
                        </Subheading>
                        <Box
                            sx={{
                                mt: 1.5,
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <Text>{t("put_this_with")}</Text>
                            <Text bold>
                                {props.returnLineToProcess?.product?.relation?.name}
                            </Text>
                        </Box>
                    </Box>
                </Box>

                <Box
                    component="footer"
                    sx={{
                        display: "flex",
                        width: 1,
                        paddingBottom: isStandAlone ? "32px" : "16px",
                        alignItems: "center",
                        paddingRight: 3,
                        paddingTop: 2,
                        background:
                            theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                        borderBottomLeftRadius: 24,
                        borderBottomRightRadius: 24,
                        justifyContent: "space-between",
                        "@media screen and (max-width: 47.9375em)": {
                            paddingRight: 0,
                            paddingLeft: 0,
                        },
                    }}
                >
                    <Shbutton
                        isCancel
                        className="always-visible"
                        onClick={props.handleClose}
                        color="primary"
                        variant="text"
                        startIcon={<ArrowRightAltIcon />}
                    >
                        {t("cancel")}
                    </Shbutton>
                    <ButtonGroup version={2}>
                        <Shbutton
                            className="group-btn"
                            color={theme.palette.mode === "dark" ? "blue" : "primary"}
                            onClick={handleConfirm}
                            variant="contained"
                        >
                            {t("confirm")}
                        </Shbutton>
                    </ButtonGroup>
                </Box>
            </Box>
        </SHModal>
    );
};

export default MReturnLocationDuplicate;
